/**
 * Re-exports getUsername from @saviynt/common.
 *
 * This file exists solely to maintain the default-export interface
 * expected by 30+ consumers in the dev/ webpack app (import getUsername from
 * 'ui-common/src/utils/getUsername'). The canonical implementation lives in
 * @saviynt/common — no duplicate logic here.
 */
import { getUsername } from '@saviynt/common';

export default getUsername;
